module.exports = __webpack_public_path__ + "static/media/quickpay.caf3db8c.png";